<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="update">
              <div class="text-danger" v-if="pesanRegister != ''"> {{ pesanRegister }}</div>
              <div class="row" v-else>
                <div v-html="description" class="mb-3">

                </div>
                <div class="text-danger mb-3" v-if="!isOn && hasMachine">
                  Masih ada mesin aktif di menu Devices. Hapus mesin dulu sebelum mengaktifkan Connected Apps.
                </div>
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2" :disabled="!isOn && hasMachine">
                    <!-- <span v-if="isOn == false">Allow Access </span>
                    <span v-else>Remove Access </span> -->
                    {{ accessLabel }}
                  </button>
                  <router-link to="connectedapps" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage, refreshPage } from "@/assets/js/function";


export default {
  // components: {
  //   Form,
  //   Field,
  // },
  name: "editlocation",
  data() {
    return {
      filter: true,
      title: "Connected Apps ",
      title1: "manage your apps",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",
      isOn: false,
      callback_on_off: "",
      description: "",
      pesanRegister: "",
      hasMachine: false,

      //data
      currentData: {
      },


      currentDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    this.namaCompany = localStorage.getItem('namaCompany');

    localStorage.setItem('actionState', 'update')


    //get data
    this.currentData = JSON.parse(localStorage.getItem('currentData'));
   
    if (this.currentData.callback_register == undefined) {
      this.cekStatus();
    } else {
      this.register();
    }

    this.cekMachine();

  },

  computed: {
    accessLabel() {
      return this.isOn ? 'Remove Access' : 'Allow Access';
    }
  },
  
  methods: {
    
    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },
    
    // Connected Apps tidak bisa diaktifkan selama masih ada mesin aktif di menu Devices
    async cekMachine() {
      let formData = new FormData();
      appendForm(formData)

      const res = await axios.post(base_url + '/v3/machine_secure/index', formData, { timeout });
      if (res.data.status) {
        this.hasMachine = res.data.data.data_machine_secure.length > 0;
      }
    },

    async update() {
      
      // let formData = new FormData();
      // appendForm(formData)

      // for (let [key, value] of formData.entries()) {
      //     console.log(`${key}: ${value}`);
      // }
      // return;
      
      const api = this.callback_on_off;
      const res = await axios.get(api);
      const data = res.data; 
      console.log('tes data:', data.data.callback_on)
      console.log('tes data off:', data.data.callback_off)

      if(data.status){
        AlertBottom(data.data.message);

        if (data.data.callback_on == undefined) {
          this.isOn = false;
          this.callback_on_off = data.data.callback_on;
          this.cekStatus()
          // refreshPage();

        } else {
          this.isOn = true;
          this.callback_on_off = data.data.callback_off;
          this.cekStatus()
          // refreshPage();
        }
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      
    },

    async cekStatus(url) {
     

      let api

      if (url == undefined) {
        api = this.currentData.callback_status;
      } else {
        api = url;
      }
      const res = await axios.get(api);
      const data = res.data;

      if(data.status){

        // AlertBottom(data.data.message);
        if (data.data.callback_on == undefined) {
          this.isOn = true;
          this.callback_on_off = data.data.callback_off;
          this.description = data.data.description;
        } else {
          this.isOn = false;
          this.callback_on_off = data.data.callback_on;
          this.description = data.data.description;
        }
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

    

     
    },

    async register() {
     

      // let formData = new FormData();
      // appendForm(formData)


      const api = this.currentData.callback_register;
      const res = await axios.get(api);
      const data = res.data;

      if(data.status){

        AlertBottom(data.data.message);
        if (data.data.callback_refresh_token == undefined) {
          console.log('tidak ada callback register');

        } else {
          this.refreshToken(data.data.callback_refresh_token);


        }
          
      }else {
          // AlertPopup2("error", "", data.message, true, 1500);
          this.pesanRegister = data.data.message;

      }
      
    
    },

    async refreshToken(url) {
      
      let formData = new FormData();
      appendForm(formData)

      const api = url;
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){

        AlertBottom(data.data.message);
        if (data.data.callback_status == undefined) {
          console.log('tidak ada callbak status');
        } else {
          this.cekStatus(data.data.callback_status);
        }
          
      }else {
        AlertPopup2("error", "", data.message, true, 1500);
          

      }


      
    }


  },

};
</script>
